module.exports = __webpack_public_path__ + "static/media/logo-light.5224144b.png";